<template>
  <span
    v-if="padding !== 0"
    class="border inline-block border-red-500 text-red-600 bg-red-200 dark:border-red-900 dark:text-dark-text dark:bg-red-900"
    :class="`${textSize}`"
    :style="`padding: ${padding}px; 
    border-radius: ${border_radius}rem;`"
  >
    {{ text }}
  </span>
  <span
    v-else
    class="border inline-block border-red-500 text-red-600 bg-red-200 dark:border-red-900 dark:text-dark-text dark:bg-red-900"
    :class="`${textSize}`"
    :style="`padding: ${padding_top}px ${padding_right}px ${padding_bottom}px ${padding_left}px; 
    border-radius: ${border_radius}rem;`"
  >
    {{ text }}
  </span>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  props: {
    text: {
      type: String,
      required: true
    },
    textSize: {
      type: String,
      default: 'text-xs'
    },
    border_radius: {
      type: Number,
      default: 0
    },
    padding: {
      type: Number,
      default: 0
    },
    padding_top: {
      type: Number,
      default: 1
    },
    padding_bottom: {
      type: Number,
      default: 1
    },
    padding_left: {
      type: Number,
      default: 1
    },
    padding_right: {
      type: Number,
      default: 1
    }
  },
  setup(props, ctx) {}
})
</script>

<style lang="postcss" scoped></style>
